export { default as VerifyWithIdMeArtwork } from './verify-with-idme.svg';

export const VerifiedByIdMeImage = require('./verified-with-idme-light.png');
